import React from "react";
import {
  Box,
  Button,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";

export interface DashboardHeaderProps {
  title?: string;
  subtitle?: string;
  period?: string;
  scenario?: string;
  costcenter?: string;
  location?: string;
  onRefresh?: () => void;
  onExport?: () => void;
}

export default function DashboardHeader({
  title = "Dashboard exécutif",
  subtitle = "Vue consolidée des budgets, de l’exécution, des performances et des alertes.",
  period = "S1 2025",
  scenario = "Révisé",
  costcenter = "Tous",
  location = "Tous",
  onRefresh,
  onExport,
}: DashboardHeaderProps) {
  return (
    <Box>
      <Stack
        direction={{ xs: "column", lg: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", lg: "center" }}
        spacing={2}
      >
        <Box>
          <Typography
            sx={{
              fontSize: { xs: 28, md: 34 },
              fontWeight: 800,
              lineHeight: 1.15,
              color: "#17324D",
              letterSpacing: "-0.03em",
            }}
          >
            {title}
          </Typography>

          <Typography sx={{ mt: 0.75, fontSize: 14, color: "#66788A", lineHeight: 1.7 }}>
            {subtitle}
          </Typography>
        </Box>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.25}>
          <Button variant="outlined" startIcon={<RefreshOutlinedIcon />} onClick={onRefresh}>
            Actualiser
          </Button>
          <Button variant="contained" startIcon={<DownloadOutlinedIcon />} onClick={onExport}>
            Exporter
          </Button>
        </Stack>
      </Stack>

      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={1.25}
        sx={{ mt: 2.5 }}
      >
        <TextField select label="Période" value={period} sx={{ minWidth: 180 }}>
          {["T1 2025", "S1 2025", "FY2025"].map((v) => (
            <MenuItem key={v} value={v}>
              {v}
            </MenuItem>
          ))}
        </TextField>

        <TextField select label="Scénario" value={scenario} sx={{ minWidth: 160 }}>
          {["Adopté", "Révisé"].map((v) => (
            <MenuItem key={v} value={v}>
              {v}
            </MenuItem>
          ))}
        </TextField>

        <TextField select label="Centre de coûts" value={costcenter} sx={{ minWidth: 220 }}>
          {["Tous", "Direction Générale", "Direction Centrale des Opérations"].map((v) => (
            <MenuItem key={v} value={v}>
              {v}
            </MenuItem>
          ))}
        </TextField>

        <TextField select label="Localisation" value={location} sx={{ minWidth: 180 }}>
          {["Tous", "Bingo", "Bobo", "Siège"].map((v) => (
            <MenuItem key={v} value={v}>
              {v}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
    </Box>
  );
}
